import { IGoal } from 'motw_core/Entity/IGoal';
import { GetCachedGoals } from '../GetCachedGoals';
import { IValidationResult, validResult } from '../ValidateEntry';

export const ValidateRequiredComment = (entryText: string): IValidationResult => {
	const goals = GetCachedGoals();
	
	if (!goals) {
		return validResult;
	}
	
	const goalsRequiringComments: string[] = goals
		.filter((goal: IGoal) => goal.iscommentrequired)
		.map((goal: IGoal) => goal.name)

	const goalName: string = entryText.split(' ')[2];
	const goalComment: string = entryText.split(' ')[4];
	const goalRequiresComment = goalsRequiringComments
		.filter((g) => goalName.includes(g)).length > 0;

	if (goalRequiresComment && !goalComment) {
		return {
			isValid: false,
			errorMessage: `Please provide a comment for this goal`
		}
	}

	return validResult;
};
